// extracted by mini-css-extract-plugin
module.exports = {"ratingNumber":"az_VIc","ratingReviews":"az_WIc","ratingsContainer":"az_XIc"};